import type { FC, Ref } from "react";

import { INDEX_NOT_FOUND } from "components/constants";
import { InteractionModeIconText } from "components/materials/page/interaction-mode/InteractionModeIconText";
import { INTERACTION_MODE_CHIP_KINDS } from "components/materials/page/interaction-mode/helpers";
import type { PageType } from "components/server-types";
import { Chip } from "mds/components/Chip";
import { isGroupPage } from "utils/page-utils";

export type InteractionModeChipProps = {
  page: PageType;
  pageGroupIndex?: number;
  disabled?: boolean;
  ref?: Ref<HTMLButtonElement>;
  onGroupCardToggle?: () => void;
  hasTooltip?: boolean;
};

export const InteractionModeChip: FC<InteractionModeChipProps> = ({
  page,
  pageGroupIndex = INDEX_NOT_FOUND,
  disabled = false,
  ref,
  onGroupCardToggle,
  hasTooltip = false,
}) => {
  const iconText = <InteractionModeIconText page={page} pageGroupIndex={pageGroupIndex} />;
  const isGroupToggle = !!onGroupCardToggle && isGroupPage(page);

  if (isGroupToggle) {
    return (
      <Chip
        as="button"
        eventName="Group Settings - Toggle"
        kind="hibiscus"
        ref={ref}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onGroupCardToggle();
        }}
      >
        {iconText}
      </Chip>
    );
  }

  if (hasTooltip || disabled) {
    return (
      <Chip
        aria-disabled={disabled || undefined}
        as="button"
        kind={INTERACTION_MODE_CHIP_KINDS[page.interaction_mode]}
        ref={ref}
      >
        {iconText}
      </Chip>
    );
  }

  return <Chip kind={INTERACTION_MODE_CHIP_KINDS[page.interaction_mode]}>{iconText}</Chip>;
};

InteractionModeChip.displayName = "InteractionModeChip";
